module.exports = __webpack_public_path__ + "static/media/walking.736a6d71.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/ActivityBadge/icons/walking.svg
// module id = 302
// module chunks = 0